<template>
  <div class="auth-wrapper auth-v2" :dir="$functions.currentLangDirection()">
    <b-row
      class="auth-inner m-0"
      style="direction: ltr;"
    >

      <!-- Brand logo-->
      <b-link class="brand-logo">

        <h2 class="brand-text text-primary ml-1" />
        <span class="brand-logo">
          <!-- <b-img
              :src="appLogoImage"
            alt="logo"
          />-->
        </span>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="12"
        class="d-none d-md-flex d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Register V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col
          lg="4"
          class="d-flex align-items-center auth-bg px-2 p-lg-3 form-auth "
          :style="{ backgroundImage: `url(${backgroundUrl})` }"
          v-bind:class="{ mainbox: !isMobile}"
          style="background-size: cover;background-position: center;direction: rtl;min-width: 350px;" >
        <b-col
          sm="12"
          md="12"
          lg="12"
          style="margin-top: -140px;"
          :dir="$functions.currentLangDirection()"
          class="box2 px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('Send verification code') }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('Enter the code sent') }}.
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="registerVerifyForm"
            #default="{invalid}"
          >
            <div
              class="auth-register-form mt-2"
            >
              <!-- security code -->
              <b-form-group
                id="div-securitycode"
                label-for="register-mobile"
                label=""
                style="direction: ltr"
              >
                  <b-form-input
                    v-model="code"
                    class="form-control auth-input height-30 text-center numeral-mask mx-25 mb-1"
                    maxlength="5"

                    style="letter-spacing: .9rem;font-size: 2.1rem"
                    name="code"
                    rules="required"
                    @keydown="bl00=$event.target.value"
                    @keyup="queryForKeywords"
                    v-on:keyup="codeChangeEn($event)"
                  />
              </b-form-group>
              <p class="text-center mt-2">
                {{ $t('Resend the code until') }}
                {{ timerCount }}
                {{ $t('Second') }}
              </p>


              <!-- username -->
              <b-form-group
                  :label="$t('Name')"
                  label-for="register-name"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Name"
                    vid="name"
                    rules="required"
                >
                  <b-form-input
                      id="register-name"
                      v-model="user.name"
                      name="register-name"
                      :dir="$functions.currentLangDirection()"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group
                  :label="$t('Family')"
                  label-for="register-family"
                  :dir="$functions.currentLangDirection()"
              >
                <validation-provider
                    #default="{ errors }"
                    name="Family"
                    vid="family"
                    rules="required"
                >
                  <b-form-input
                      id="register-family"
                      v-model="user.family"
                      name="register-family"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-button
                  class="mt-3"
                  @click="registerVerifyForm"
                variant="success"
                block
                type="submit"
                :disabled="invalid && loading"
              ><b-spinner variant="outline-primary" small  v-if="loading"></b-spinner>
                {{ $t('Send') }}
              </b-button>
            </div>
          </validation-observer>

          <p class="text-center mt-4">
            <span>{{ $t('No code sent') }}</span>
            <b-link :to="{name:'login'}">
              <span style="font-weight: bolder; text-decoration: underline">&nbsp;{{ $t('Change mobile number') }}</span>
            </b-link>
          </p>

          <!-- divider -->


        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import Vue from 'vue'
import store from '@/store/index'
import User from '@/models/user'
import { functions } from '@/functions'

Vue.prototype.$functions = functions

export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BSpinner,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      user: new User('', '', '', '', ''),
      code: '',
      status: '',
      username: '',
      userEmail: '',
      password: '',
      sideImg: require('@/assets/images/pages/login-v2.jpg'),
      backgroundImg: require('@/assets/images/pages/lg.jpg'),
      // validation
      required,
      email,
      bl00: '1',
      timerEnabled: true,
      timerCount: 300,
      isMobile: Vue.prototype.$functions.isMobile(),
      loading: false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      return this.sideImg
    },
    backgroundUrl() {
      return this.backgroundImg
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            // eslint-disable-next-line no-plusplus
            this.timerCount--
            if (this.timerCount === 0) {
              this.$router.push('/login')
              // console.log(this.timerCount)
            }
          }, 1000)
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  beforeCreate() {
    if (typeof this.$mobileR === 'undefined') {
    //  this.$router.push('/login')
    }
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  mounted() {
    const { isRTL } = $themeConfig.layout
    const formGroup = document.getElementsByClassName('form-auth')
    formGroup[0].style.direction = isRTL ? 'rtl' : 'ltr'
    document.getElementById('div-securitycode').getElementsByTagName('input')[0].focus()
  },
  methods: {
    registerVerifyForm() {
      this.$refs.registerVerifyForm.validate().then(success => {
        if (success) {
          this.loading = true
          this.$store.dispatch('auth/registerVerify', {
            code: this.code,
            mobile: this.$mobileR,
            name: this.user.name,
            family: this.user.family,
          }).then(
            () => {
              this.loading = false
              this.$router.push('/newdevice')
            }, error => {
              this.loading = false
              this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Error'),
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                  dir: Vue.prototype.$functions.currentLangDirection(),
                },
              })
            },
          )
        }
      })
    },
    queryForKeywords() {
      this.$nextTick(() => {
        if (this.code.length === 5) {
          this.registerVerifyForm()
        }
      })
    },
    codeChangeEn(event) {
      this.code = this.$functions.fixNumbers(event.target.value)
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
[dir=ltr], [dir=ltr] .ltr * {
  direction: ltr !important;
  text-align: left;
}

@import '../../@core/scss/vue/pages/page-auth.scss';
.brand-logo img{
  width: 70px;
}
.auth-wrapper .auth-bg{
  background-color: #232633;
  color: #fff;
}
.auth-wrapper label,.auth-wrapper span,.auth-wrapper h2,.auth-wrapper .brand-text{
  color: #fff !important;
}

.mainbox{
  background: #344935d6   !important;
  position: absolute;top: 10%;margin-left: auto;margin-right: auto;left: 0;right: 0;width: 400px;height: 500px;border-radius: 2%;
}
.mainbox .box2{
  margin-top: -40px !important;
}
</style>
